<script>
import Icon from "@/components/atoms/icon";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";

export default {
  name: "OrderSummaryObjets",
  components: { Icon, List, ListItem },
  props: {
    objets: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <div
    v-if="objets.length > 0"
    class="c-order-summary-objets u-inline-flex"
  >
    <Icon
      class="u-mr-md u-mt-xxs u-flex"
      variant="primary"
      name="avantages"
      size="sm"
    />
    <List class="u-color-primary c-order-summary-objets__list-gift u-flex u-flex-column">
      <ListItem
        v-for="(objet, index) in objets"
        :key="`objets-${index}`"
        class="u-font-15 u-mb-xxs"
      >
        {{ objet.valeur }} {{ uppercaseFirstLetter(lowercase(objet.libelle)) }} {{ pluralize(objet.valeur, "collecté(e)") }}
      </ListItem>
    </List>
  </div>
</template>

<style lang="scss" scoped>
.c-order-summary-objets__list-gift {
  list-style: disc;
  margin-top: spacing(xs);
}
</style>
